import { render } from "./WebchatUiCustomConfiguration.vue?vue&type=template&id=6654aea6&scoped=true&lang=pug"
import script from "./WebchatUiCustomConfiguration.vue?vue&type=script&lang=js"
export * from "./WebchatUiCustomConfiguration.vue?vue&type=script&lang=js"

import "./WebchatUiCustomConfiguration.vue?vue&type=style&index=0&id=6654aea6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6654aea6"]])

export default __exports__